var _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 433.68 122.54",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 1218.66,
    y1: -2426.37,
    x2: 1218.66,
    y2: -1138.34,
    gradientTransform: "matrix(0.07, 0, 0, -0.07, 1.24, -52.15)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#006"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#008fd7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 522.89,
    y1: -1973.63,
    x2: 522.89,
    y2: -762.66,
    gradientTransform: "matrix(0.07, 0, 0, -0.07, 1.24, -52.15)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fc0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 2646.91,
    y1: -2073.37,
    x2: 2646.91,
    y2: -1298.82,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 4627.61,
    y1: -2097.99,
    x2: 4627.61,
    y2: -1289.82,
    xlinkHref: "#b"
  }))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "TelSmart Logo - No tagline") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M114.9,29.81H63.05A12.93,12.93,0,0,0,50.13,42.74V94.58a12.93,12.93,0,0,0,12.92,12.93H91l.19,15,16.82-15h6.94a13,13,0,0,0,12.93-12.93V42.74A13,13,0,0,0,114.9,29.81Zm-9.36,54.77v.13H72.29a8.28,8.28,0,0,1,0-16.56l-.13.06a9,9,0,0,1,1.91.2A12,12,0,0,1,74,66.94,13.57,13.57,0,0,1,101,64.58a11.1,11.1,0,0,1,4.59-1,10.51,10.51,0,0,1,0,21Z",
    style: {
      fill: "url(#a)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.54,84.58v.13H72.29a8.28,8.28,0,0,1,0-16.56l-.13.06a9,9,0,0,1,1.91.2A12,12,0,0,1,74,66.94a13.51,13.51,0,0,1,3.07-8.61L50.13,83.56v11a12.93,12.93,0,0,0,12.92,12.93H91l22.93-26.94-.07,0A10.47,10.47,0,0,1,105.54,84.58Z",
    style: {
      fill: "#002570"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13,0H64.84A12.94,12.94,0,0,1,77.77,12.93v12H59.42A14.36,14.36,0,0,0,45.09,39.23V77.7H36.88l-.19,15-16.82-15H12.93A13,13,0,0,1,0,64.77V12.93A13,13,0,0,1,12.93,0Z",
    style: {
      fill: "url(#b)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M194.39,49.3c6.43,0,9.87-3.19,10.06-10.19a25.88,25.88,0,0,1-9.3,1.65c-7.9,0-10.83-1.84-20.57-1.84-19.81,0-27.39,10.19-27.39,20.89,0,5.79,3.06,7.77,8.6,7.77-.06-.7-1.15-1.34-1.15-5.48,0-12.93,6.56-16.24,15.1-16.24h.95L159.29,99h11.6L182,47.45a59.2,59.2,0,0,0,12.42,1.78Zm1.78,36.75a27.89,27.89,0,0,1,.19-3.19c9.62-.57,18.47-7.7,18.47-16.94,0-4-1.65-7.71-8.85-7.71-16.43,0-21.66,19.37-21.66,28.6,0,9,5,12.74,12.55,12.74,10.7,0,17.52-7.45,22.1-14.84h-2.74c-4,4.59-7.89,8.09-14.2,8.09-3.88,0-5.8-1.27-5.8-6.75Zm12.42-20.32c0,6.69-5.48,12.87-11.65,13.25,1.59-8,5.54-16.56,9.61-16.56C208.08,62.42,208.59,63.69,208.59,65.73Zm27.83-23.06-11.91,1.6-8.59,40.25a27,27,0,0,0-.64,5.22c0,6.82,3.76,9.81,8.6,9.81,4.33,0,8.4-2.74,8.85-8.41a5,5,0,0,1-2.55.51c-2.48,0-3.31-1.33-3.31-3.18a17,17,0,0,1,.32-2.36l9.23-43.37Z",
    style: {
      fill: "url(#c)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.68,48.47c0-8.85-9.17-9.62-12.93-9.62-10.38,0-18.54,6-18.54,14.4,0,11.78,16.44,16.68,16.44,30.44,0,6.75-3.95,10.7-9.3,10.7-5.16,0-7.71-3.69-7.71-7.71,0-5.54,5-7.51,9.36-7.51-.25-4.2-4.26-5.29-7.07-5.29-5.6,0-11.78,4.52-11.78,13.19,0,9.81,7.9,13.82,17,13.82,11.65,0,22.54-6.56,22.54-20.06,0-17.33-18.09-18.92-18.09-30.77,0-4.84,3-7.32,7.39-7.32s5.93,2.54,5.93,5.35A8.36,8.36,0,0,1,266.3,55,4.47,4.47,0,0,0,270,56.62c4,0,6.56-3.44,6.56-8.09h0Zm45,21.53c0,5.16-3.63,15-3.63,20.44,0,4.59,2.48,9,9.49,9,4.26,0,10.44-1.66,14.9-14.84H339.1c-1.79,4.2-3.19,7.07-6.76,7.07-2.42,0-3.18-1.34-3.18-3.38,0-4.52,3.88-14.2,3.88-20.7s-3.75-9-8.91-9c-3,0-7.33.89-11.15,6.81-.89-5-4-6.88-8.28-6.88a12.3,12.3,0,0,0-9.81,4.59l.9-4.2h-11.6L275.66,99h11.59l5.48-25.79c1.21-4,3.37-7.46,6.49-7.46,1.79,0,2.42,1.79,2.42,3.51a7.43,7.43,0,0,1-.25,2L295.53,99h11.59l5.48-25.79c1.21-4,3.38-7.39,6.24-7.39,1.91,0,2.87,1.46,2.87,4.07h0ZM366.1,58.92l-.89,4.26v-.57c0-2.36-1.91-4.08-6.5-4.08-13.95,0-20.63,17.26-20.63,28.09,0,9.55,5.22,12.93,10.7,12.93,5.73,0,9.49-3.69,12-7.39.51,4.84,3.38,7.39,7.9,7.39,4.33,0,11.59-1.78,16.11-14.84h-3.37c-1.21,4-3.38,7.52-6.5,7.52-2.23,0-3.31-1.21-3.31-3.44a10,10,0,0,1,.32-2.55l5.79-27.32Zm-4.9,4.58a3.16,3.16,0,0,1,3.31,3.06l-3.89,18.15c-.95,4.65-4.33,7.07-6.68,7.07-1.47,0-4-.06-4-6.24,0-7.52,4.4-22,11.21-22Zm25.6-4.58L378.27,99h11.59l6.43-30.51c2-1.84,3.44-3,5.86-3s.19,5.28,4.65,5.28a5.62,5.62,0,0,0,5.8-5.86c0-3.06-1.91-6.05-5.55-6.05-3.88,0-6.87,2.55-9.74,5l1-5H386.74Zm41.4,3.18H433l.64-3.18h-4.84c1.53-7.2,2.74-12.68,2.74-12.68l-11.91,1.59-2.42,11.09h-2.68l-.64,3.18h2.68l-5.16,24.08a19.81,19.81,0,0,0-.51,4.26c0,5.16,2.42,9,8,9,2.73,0,6.24-1,8.53-7.9a6.25,6.25,0,0,1-2.1.25c-2.17,0-2.8-1.21-2.8-2.86a14.8,14.8,0,0,1,.38-2.8l5.16-24.08Z",
    style: {
      fill: "url(#d)"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.f496bf93ead49564dcf0566c660ecf76.svg";
export { ForwardRef as ReactComponent };